export default __webpack_public_path__ + "static/media/plan.dee0a7c5.svg";